'use es6';

import { RECEIVED_CRM_OBJECT_ID, RECEIVED_CRM_OBJECTS, REQUESTED_CRM_OBJECTS, REQUESTED_CRM_OBJECTS_FAILED } from '../actions/ActionTypes';
import { RequestStatus } from '../constants/base';
import CrmObjects from '../models/CrmObjects';
export default ((state = new CrmObjects(), action) => {
  switch (action.type) {
    case REQUESTED_CRM_OBJECTS:
      return state.set('crmDynamicPageObjectsStatus', RequestStatus.PENDING);

    case RECEIVED_CRM_OBJECTS:
      return state.merge({
        crmDynamicPageObjects: action.payload.crmObjects,
        crmDynamicPageObjectsStatus: RequestStatus.SUCCEEDED
      });

    case REQUESTED_CRM_OBJECTS_FAILED:
      return state.set('crmDynamicPageObjectsStatus', RequestStatus.FAILED);

    case RECEIVED_CRM_OBJECT_ID:
      return state.merge({
        crmPageObjectId: action.payload.objectId
      });

    default:
      return state;
  }
});